module.exports = __webpack_public_path__ + "static/img/kassa24.6b436931.svg";